import { Component, OnInit } from '@angular/core';
import { Venda } from 'src/app/core/models/venda';
import { VendaService } from 'src/app/core/services/venda.service';
import { VendedorService } from 'src/app/core/services/vendedor.service';
import { ClienteService } from 'src/app/core/services/cliente.service';
import { ProdutoService } from 'src/app/core/services/produto.service';
import { MessageService } from 'primeng/api';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';

@Component({
  selector: 'app-buscar-venda',
  templateUrl: './buscar-venda.component.html',
  styleUrls: ['./buscar-venda.component.scss']
})
export class BuscarVendaComponent implements OnInit {
  termoBusca: string = '';
  vendas: Venda[] = [];
  vendaEditando: Venda | null = null;
  novoItem: {
    produto: any;
    quantidade: number;
    preco: number;
    valorDesconto: number;
    valorAcrescimo: number;
  } = {
    produto: null,
    quantidade: 1,
    preco: 0,
    valorDesconto: 0,
    valorAcrescimo: 0
  };
  vendedores: any[] = [];
  clientes: any[] = [];
  produtos: any[] = [];
  pagamentos: string[] = [
    'DINHEIRO',
    'CARTAO_1X',
    'CARTAO_2X',
    'CARTAO_3X',
    'CARTAO_4X',
    'CARTAO_5X',
    'CARTAO_6X',
    'CARTAO_7X',
    'CARTAO_8X',
    'CARTAO_9X',
    'CARTAO_10X',
    'CARTAO_11X',
    'CARTAO_12X',
    'CARTAO_13X',
    'CARTAO_14X',
    'CARTAO_15X',
    'CARTAO_16X',
    'CARTAO_17X',
    'CARTAO_18X',
    'CARTAO_DEBITO',
    'PIX',
    'TRANSFERENCIA',
    'PRAZO'
  ];

    statusOptions = [
    { label: 'Pedido', value: 'PEDIDO' },
    { label: 'Venda', value: 'VENDA' }
  ];

  constructor(
    private vendaService: VendaService,
    private vendedorService: VendedorService,
    private clienteService: ClienteService,
    private produtoService: ProdutoService,
    private messageService: MessageService,
    private readonly errorHandler: ErrorHandlerService
  ) {}

  ngOnInit(): void {
    // Carrega vendedores ao iniciar
    this.vendedorService.selecionar().subscribe((vendedores) => {
      this.vendedores = vendedores;
    });
    // Carrega clientes ao iniciar
    this.clienteService.selecionar().subscribe((clientes) => {
      this.clientes = clientes;
    });
    // Carrega produtos ao iniciar
    this.produtoService.selecionar().subscribe((produtos) => {
      this.produtos = produtos;
    });
  }

  buscarVendas(): void {
    this.vendaEditando = null;
    const termo = this.termoBusca.trim();
    // Busca por ID (número)
    if (!isNaN(Number(termo))) {
      const vendaId = Number(termo);
      this.vendaService.buscaPedidoOuOrcamentoPorId(vendaId).subscribe({
        next: venda => {
          this.vendas = venda ? [venda] : [];
          if (!venda) {
            this.mostrarMensagem('Pedido não encontrado.', vendaId);
          }
        },
        error: (err) => {
          let msg = err?.error?.message || err?.error?.userMessage || 'Não há pedido com o ID informado.';
          if (!msg && this.errorHandler) {
            msg = this.errorHandler.getErrorMessage(err);
          }
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
        }
      });
      return;
    }
    // Busca por nome do cliente ou vendedor
    this.vendaService.selecionar().subscribe(vendas => {
      this.vendas = vendas.filter(v =>
        (['PEDIDO', 'ORCAMENTO'].includes(v.vendaSituacao)) &&
        (
          (v.cliente && v.cliente.nome && v.cliente.nome.toLowerCase().includes(termo.toLowerCase())) ||
          (v.vendedor && v.vendedor.nome && v.vendedor.nome.toLowerCase().includes(termo.toLowerCase()))
        )
      );
      if (!this.vendas.length) {
        this.mostrarMensagem('Pedido não encontrado.');
      }
    });
  }

  mostrarMensagem(msg: string, vendaId?: number) {
    let detail = msg;
    if (vendaId !== undefined) {
      detail = `Venda Nº ${vendaId} não encontrada!`;
    }
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail });
  }

  editarVenda(venda: Venda): void {
    // Cria uma cópia para edição
    this.vendaEditando = JSON.parse(JSON.stringify(venda));
    // Ajusta o vendedor para o objeto correto da lista de vendedores
    if (this.vendaEditando && this.vendaEditando.vendedor && this.vendedores.length) {
      const vendedorId = this.vendaEditando.vendedor.id;
      const vendedorObj = this.vendedores.find(v => v.id === vendedorId);
      if (vendedorObj) {
        this.vendaEditando.vendedor = vendedorObj;
      }
    }
  }

  salvarEdicao(): void {
    if (!this.vendaEditando || this.vendaEditando.id == null) return;
    // Chama o serviço para salvar a edição (PUT /vendas/{id})
    this.vendaService.alterar(this.vendaEditando.id, this.vendaEditando).subscribe({
      next: (vendaAtualizada) => {
        // Atualiza localmente a lista de vendas
        const idx = this.vendas.findIndex(v => v.id === vendaAtualizada.id);
        if (idx !== -1) {
          this.vendas[idx] = vendaAtualizada;
        }
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Venda alterada com sucesso!' });
        this.vendaEditando = null;
        this.vendas = []; // Limpa a tabela de vendas após salvar
      },
      error: (err) => {
        let msg = 'Erro ao salvar venda.';
        if (err?.error?.message) msg = err.error.message;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
      }
    });
  }

  cancelarEdicao(): void {
    this.vendaEditando = null;
  }

  addItemVenda(): void {
    if (!this.vendaEditando || !this.novoItem.produto) return;
    const produto = this.novoItem.produto as any;
    // Se o campo preco não estiver preenchido, usa o preco do produto selecionado
    const preco = this.novoItem.preco > 0 ? this.novoItem.preco : (produto.preco || 0);
    const itemVenda = {
      produto,
      quantidade: this.novoItem.quantidade,
      valorDesconto: this.novoItem.valorDesconto,
      valorAcrescimo: this.novoItem.valorAcrescimo,
      valorTotal: (preco * this.novoItem.quantidade) - this.novoItem.valorDesconto + this.novoItem.valorAcrescimo
    };
    if (!this.vendaEditando.itens) this.vendaEditando.itens = [];
    this.vendaEditando.itens.push(itemVenda as any);
    // Limpa campos
    this.novoItem = {
      produto: null,
      quantidade: 1,
      preco: 0,
      valorDesconto: 0,
      valorAcrescimo: 0
    };
  }

  removerItemVenda(index: number): void {
    if (!this.vendaEditando || !this.vendaEditando.itens) return;
    this.vendaEditando.itens.splice(index, 1);
  }

  get pagamentosOptions() {
    return this.pagamentos.map(p => ({ label: p, value: p }));
  }

    get statusVendaOptions() {
    return this.statusOptions.map(p => ({ label: p, value: p }));
  }
}
